export default "__VITE_ASSET__BYtnrHkk__"